import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { TrackedDialog } from '@eneco/components/TrackedDialog/TrackedDialog';
import { Box, Card, Heading, Stack, TextLink } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { ConsumptionGraphicalOverviewRendering } from '@sitecore/types/ConsumptionGraphicalOverview';

const CapacityRateInformationBox: FC = () => {
  const { fields } = useContent<ConsumptionGraphicalOverviewRendering>();
  return (
    <Card>
      <Box padding="6">
        <Stack gap="4">
          <Heading as="h3" size="XS">
            {fields.data.capacityRateTitle?.value || 'Het capaciteitstarief [Not in Sitecore]'}
          </Heading>
          <RichText
            html={
              fields.data.capacityRateText?.value ||
              'Zo werkt de berekening voor je gebruik van het elektriciteitsnet. [Not in Sitecore]'
            }
          />
          <TrackedDialog
            trigger={
              <TextLink emphasis="high">
                {fields.data.capacityRateLink.value.text || 'Meer informatie [Not in Sitecore]'}
              </TextLink>
            }
            title={
              fields.data.capacityRateInformationDialog?.value?.title || 'Het capaciteitstarief [Not in Sitecore]'
            }>
            <RichText
              html={
                fields.data.capacityRateInformationDialog?.value?.content ||
                'Zo werkt de berekening voor je gebruik van het elektriciteitsnet. [Not in Sitecore]'
              }
            />
          </TrackedDialog>
        </Stack>
      </Box>
    </Card>
  );
};

export default CapacityRateInformationBox;
